var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAyologo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 537,
    height: 214,
    viewBox: "0 0 537 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-138 -233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(138 233)",
    fill: "#1C1C1C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 199.1909790039062 199.5 L 0.80902498960495 199.5 L 100 1.1180499792099 L 199.1909790039062 199.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 2.236053466796875 L 1.618026733398438 199 L 198.3819732666016 199 L 100 2.236053466796875 M 100 0 L 200 200 L 0 200 L 100 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    transform: "translate(500 433) rotate(180)",
    fill: "#1C1C1C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 199.1909790039062 199.5 L 0.80902498960495 199.5 L 100 1.1180499792099 L 199.1909790039062 199.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 2.236053466796875 L 1.618026733398438 199 L 198.3819732666016 199 L 100 2.236053466796875 M 100 0 L 200 200 L 0 200 L 100 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    transform: "translate(349 384.568)",
    fill: "#1C1C1C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.19098663330078 49.5 L 0.8090149760246277 49.5 L 25 1.118029952049255 L 49.19098663330078 49.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 2.236068725585938 L 1.618034362792969 49 L 48.38196563720703 49 L 25 2.236068725585938 M 25 0 L 50 50 L 0 50 L 25 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(500 233)",
    fill: "#1C1C1C",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(575 422)",
    fill: "none",
    stroke: "#1C1C1C",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 10.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyologo);
export default __webpack_public_path__ + "static/media/ayologo.1f2c6b61be850b488969ea4c7390d939.svg";
export { ForwardRef as ReactComponent };